// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ------------------------------------------------------------------------
 * @author      CEBS Worldwide
 * @copyright   � 2025 CEBS Worldwide. All rights reserved.
 * @license     STRICTLY CONFIDENTIAL
 * ------------------------------------------------------------------------
 * Styling for ReportsExportPage.jsx
 */

.page-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  background-color: #f8f9fc;
}

.dashboard-body {
  display: flex;
  flex: 1 1;
}

.dashboard-content {
  flex-grow: 1;
  padding: 20px 30px;
  background-color: #fff;
}

.reports-header {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.reports-header select,
.reports-header input[type="date"],
.reports-header button {
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 14px;
}

.reports-header button {
  background-color: #007bff;
  color: white;
  border: none;
  cursor: pointer;
  transition: background 0.3s ease;
}

.reports-header button:hover {
  background-color: #0056b3;
}

.reports-table {
  width: 100%;
  border-collapse: collapse;
  background-color: #ffffff;
  margin-top: 10px;
  border-radius: 6px;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.05);
}

.reports-table thead {
  background-color: #f1f3f5;
  font-weight: bold;
}

.reports-table th,
.reports-table td {
  padding: 12px 14px;
  border: 1px solid #dee2e6;
  font-size: 14px;
  text-align: left;
}

.reports-table tbody tr:nth-child(even) {
  background-color: #f9f9f9;
}

.reports-table tbody tr:hover {
  background-color: #f0f4fa;
  transition: 0.3s;
}

.no-data {
  padding: 30px;
  text-align: center;
  font-size: 16px;
  color: #888;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.05);
}

/* Responsive */
@media (max-width: 768px) {
  .reports-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .reports-header select,
  .reports-header input,
  .reports-header button {
    width: 100%;
    margin-bottom: 10px;
  }

  .dashboard-content {
    padding: 15px;
  }

  .reports-table {
    font-size: 13px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/demo/reports/ReportsExport.css"],"names":[],"mappings":"AAAA;;;;;;EAME;;AAEF;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,4DAA4D;EAC5D,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAO;AACT;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;;EAGE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA,eAAe;AACf;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;;;IAGE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* ------------------------------------------------------------------------\n * @author      CEBS Worldwide\n * @copyright   � 2025 CEBS Worldwide. All rights reserved.\n * @license     STRICTLY CONFIDENTIAL\n * ------------------------------------------------------------------------\n * Styling for ReportsExportPage.jsx\n */\n\n.page-container {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  background-color: #f8f9fc;\n}\n\n.dashboard-body {\n  display: flex;\n  flex: 1;\n}\n\n.dashboard-content {\n  flex-grow: 1;\n  padding: 20px 30px;\n  background-color: #fff;\n}\n\n.reports-header {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  margin-bottom: 20px;\n  flex-wrap: wrap;\n}\n\n.reports-header select,\n.reports-header input[type=\"date\"],\n.reports-header button {\n  padding: 8px 12px;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  font-size: 14px;\n}\n\n.reports-header button {\n  background-color: #007bff;\n  color: white;\n  border: none;\n  cursor: pointer;\n  transition: background 0.3s ease;\n}\n\n.reports-header button:hover {\n  background-color: #0056b3;\n}\n\n.reports-table {\n  width: 100%;\n  border-collapse: collapse;\n  background-color: #ffffff;\n  margin-top: 10px;\n  border-radius: 6px;\n  box-shadow: 0 0 8px rgba(0, 0, 0, 0.05);\n}\n\n.reports-table thead {\n  background-color: #f1f3f5;\n  font-weight: bold;\n}\n\n.reports-table th,\n.reports-table td {\n  padding: 12px 14px;\n  border: 1px solid #dee2e6;\n  font-size: 14px;\n  text-align: left;\n}\n\n.reports-table tbody tr:nth-child(even) {\n  background-color: #f9f9f9;\n}\n\n.reports-table tbody tr:hover {\n  background-color: #f0f4fa;\n  transition: 0.3s;\n}\n\n.no-data {\n  padding: 30px;\n  text-align: center;\n  font-size: 16px;\n  color: #888;\n  background: #fff;\n  border-radius: 6px;\n  box-shadow: 0 0 6px rgba(0, 0, 0, 0.05);\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .reports-header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .reports-header select,\n  .reports-header input,\n  .reports-header button {\n    width: 100%;\n    margin-bottom: 10px;\n  }\n\n  .dashboard-content {\n    padding: 15px;\n  }\n\n  .reports-table {\n    font-size: 13px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
